
import { useState, useCallback } from "react";

export interface VoiceSettings {
  continuousMode: boolean;
  autoVoiceResponse: boolean;
  voiceOnlyMode: boolean;
  preferredLanguage: string;
  useElevenLabs: boolean; // Nouveau paramètre
}

export function useVoiceSettings() {
  const [settings, setSettings] = useState<VoiceSettings>({
    continuousMode: false,
    autoVoiceResponse: true, // Activé par défaut
    voiceOnlyMode: false,
    preferredLanguage: 'ht', // Créole haïtien par défaut
    useElevenLabs: true // ElevenLabs activé par défaut
  });

  const updateSettings = useCallback((newSettings: Partial<VoiceSettings>) => {
    setSettings(prev => {
      const updated = { ...prev, ...newSettings };
      console.log("🔧 Paramètres vocaux mis à jour:", updated);
      return updated;
    });
  }, []);

  const getCurrentSettings = useCallback(() => {
    return settings;
  }, [settings]);

  const toggleContinuousMode = useCallback(() => {
    updateSettings({ continuousMode: !settings.continuousMode });
  }, [settings.continuousMode, updateSettings]);

  const toggleAutoVoiceResponse = useCallback(() => {
    updateSettings({ autoVoiceResponse: !settings.autoVoiceResponse });
  }, [settings.autoVoiceResponse, updateSettings]);

  const toggleVoiceOnlyMode = useCallback(() => {
    updateSettings({ voiceOnlyMode: !settings.voiceOnlyMode });
  }, [settings.voiceOnlyMode, updateSettings]);

  const toggleElevenLabs = useCallback(() => {
    updateSettings({ useElevenLabs: !settings.useElevenLabs });
  }, [settings.useElevenLabs, updateSettings]);

  const setLanguage = useCallback((language: string) => {
    updateSettings({ preferredLanguage: language });
  }, [updateSettings]);

  return {
    settings,
    updateSettings,
    getCurrentSettings,
    toggleContinuousMode,
    toggleAutoVoiceResponse,
    toggleVoiceOnlyMode,
    toggleElevenLabs,
    setLanguage
  };
}
